import { Link } from 'react-router-dom'
import AdBanner from './AdBanner'

const FOOTER_SOCIALS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/1ishvar.az',
    viewBox: '0 0 24 24',
    path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z',
  },
  {
    label: 'TikTok',
    href: 'https://www.tiktok.com/@1ishvar.az',
    viewBox: '0 0 24 24',
    path: 'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z',
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/groups/4622548774685583',
    viewBox: '0 0 24 24',
    path: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z',
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@1ishvaraz',
    viewBox: '0 0 24 24',
    path: 'M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z',
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/1ishvaraz',
    viewBox: '0 0 24 24',
    path: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
  },
]

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="site-footer" style={{
      marginTop: '4rem',
      borderTop: '1px solid rgba(255,255,255,.06)',
      background: 'rgba(255,255,255,.015)',
      backdropFilter: 'blur(12px)',
    }}>
      {/* Footer reklam banneri */}
      <div style={{ maxWidth: 1000, margin: '0 auto', padding: '1.5rem 2rem 0' }}>
        <AdBanner placement="FOOTER" variant="footer" />
      </div>

      {/* Əsas footer məzmunu */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '2.5rem 1.25rem' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '2rem',
          marginBottom: '2.5rem',
        }}>
          {/* Brand */}
          <div>
            <div style={{ fontWeight: 900, fontSize: '1.1rem', letterSpacing: '.02em', marginBottom: '.75rem' }}>
            1ishvar<span style={{ color: 'var(--accent)' }}>.</span>az
            </div>
            <p style={{ fontSize: '.8rem', color: 'var(--muted)', lineHeight: 1.7 }}>
          Azərbaycanın iş axtaran platforması. Günlük işçilər və işəgötürənlər arasında körpü.
            </p>
          </div>

          {/* Platform */}
          <div>
            <div style={{ fontWeight: 700, fontSize: '.8rem', textTransform: 'uppercase',
              letterSpacing: '.1em', color: 'var(--muted)', marginBottom: '1rem' }}>
              Platform
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
              {[
                { to: '/',            label: 'Elanlar' },
                { to: '/about',       label: 'Haqqımızda' },
                { to: '/contact',     label: 'Əlaqə' },
                { to: '/advertise',   label: 'Reklam ver' },
              ].map(l => (
                <li key={l.to}>
                  <Link to={l.to} style={{ fontSize: '.82rem', color: 'var(--muted)', textDecoration: 'none',
                    transition: 'color .15s' }}
                    onMouseEnter={e => e.currentTarget.style.color = 'var(--text)'}
                    onMouseLeave={e => e.currentTarget.style.color = 'var(--muted)'}
                  >{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* İstifadəçi */}
          <div>
            <div style={{ fontWeight: 700, fontSize: '.8rem', textTransform: 'uppercase',
              letterSpacing: '.1em', color: 'var(--muted)', marginBottom: '1rem' }}>
              İstifadəçi
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
              {[
                { to: '/register',     label: 'Qeydiyyat' },
                { to: '/login',        label: 'Daxil ol' },
                { to: '/profile',      label: 'Profilim' },
                { to: '/my-applications', label: 'Müraciətlərim' },
              ].map(l => (
                <li key={l.to}>
                  <Link to={l.to} style={{ fontSize: '.82rem', color: 'var(--muted)', textDecoration: 'none',
                    transition: 'color .15s' }}
                    onMouseEnter={e => e.currentTarget.style.color = 'var(--text)'}
                    onMouseLeave={e => e.currentTarget.style.color = 'var(--muted)'}
                  >{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Hüquqi */}
          <div>
            <div style={{ fontWeight: 700, fontSize: '.8rem', textTransform: 'uppercase',
              letterSpacing: '.1em', color: 'var(--muted)', marginBottom: '1rem' }}>
              Hüquqi
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
              {[
                { to: '/privacy',      label: 'Məxfilik siyasəti' },
                { to: '/terms',        label: 'İstifadə şərtləri' },
                { to: '/advertise',    label: 'Reklam yerləri' },
                { to: '/partnerships', label: 'Bizimlə işləyin' },
              ].map(l => (
                <li key={l.to}>
                  <Link to={l.to} style={{ fontSize: '.82rem', color: 'var(--muted)', textDecoration: 'none',
                    transition: 'color .15s' }}
                    onMouseEnter={e => e.currentTarget.style.color = 'var(--text)'}
                    onMouseLeave={e => e.currentTarget.style.color = 'var(--muted)'}
                  >{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Alt xətt */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,.06)',
          paddingTop: '1.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '.75rem',
          fontSize: '.75rem',
          color: 'var(--muted)',
        }}>
          <span>© {year} 1ishvar.az — Bütün hüquqlar qorunur</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '.7rem', flexWrap: 'wrap' }}>
            {FOOTER_SOCIALS.map(social => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                title={social.label}
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  border: '1px solid rgba(255,255,255,.1)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--text)',
                  textDecoration: 'none',
                  background: 'rgba(255,255,255,.02)',
                  transition: 'border-color .2s, background .2s, transform .2s',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = 'rgba(var(--accent-rgb),.35)'
                  e.currentTarget.style.background = 'rgba(var(--accent-rgb),.08)'
                  e.currentTarget.style.transform = 'translateY(-1px)'
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = 'rgba(255,255,255,.1)'
                  e.currentTarget.style.background = 'rgba(255,255,255,.02)'
                  e.currentTarget.style.transform = 'translateY(0)'
                }}
              >
                <svg
                  viewBox={social.viewBox}
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ width: 17, height: 17, fill: 'currentColor' }}
                >
                  <path d={social.path} />
                </svg>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
